import request from "./request";

export const getUserInfo = () => {
  return request({
    url: "/user/getUserInfo",
  });
};

// 学员认证申请信息  0-未申请; 1-待通过; 2-未通过; 3-已通过
export const getUserApply = () => {
  return request({
    url: "/user/apply/student/getUserApply",
  });
};

// 获取主题信息
export const getPlatformDetail = (params) => {
  return request({
    url: "/platform/index/config",
    method: "get",
    params,
  });
};

// 获取验证码前先获取图形验证码
export const getCaptchaAuth = () => {
  return request({
    url: "/user/getCaptcha",
  });
};
// 登录发送验证码
export const sendCode = (params) => {
  return request({
    url: "/user/sendCode",
    params,
  });
};

// 短息验证码登录
export const login = (data) => {
  return request({
    url: "/weChat/sms/login",
    data,
    method: "post",
    showLoading: true,
  });
};

// 短息验证码登录
export const login2 = (data) => {
  return request({
    url: "/user/student/sms/login",
    data,
    method: "post",
    showLoading: true,
  });
};

// 生成一次性CODE绑定TOKEN
export const tokenGetCode = (params) => {
  return request({
    url: `/user/generate/code`,
    method: "get",
    params,
    showLoading: true,
  });
};

// 添加用户网页浏览记录
export const addPageBrowserRecord = (data) => {
  return request({
    url: "/user/addPageBrowserRecord",
    method: "post",
    data,
  });
};
